export default __webpack_public_path__ + "static/media/Others_Skipping_Rope.6b479f74.svg";